/** The not-found piece's behavior half: knows the address asked for and goes home. Draws nothing. */
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { usePieceEmit, usePieceOptions, type PieceInput, type PieceRuntime } from '../../contract/runtime';
import { usePageMover } from '../../pageMover';
import { contract, type NotFoundActions, type NotFoundEvents, type NotFoundState } from './contract';

export type NotFoundRuntime = PieceRuntime<typeof contract, NotFoundState, NotFoundActions>;

export function useNotFound(input: PieceInput<NotFoundEvents> = {}): NotFoundRuntime {
  const options = usePieceOptions(contract, input.options);
  const emit = usePieceEmit(input.onEvent);
  const navigate = usePageMover();
  const { pathname, search, hash } = useLocation();
  const path = `${pathname}${search}${hash}`;

  const actions = useMemo<NotFoundActions>(
    () => ({
      goHome: () => {
        emit('wentHome', { path });
        navigate('/');
      },
    }),
    [path, emit, navigate],
  );

  return { state: { path }, actions, options };
}
